import React, { Component } from 'react';
import { Button } from "reactstrap";
import { inject, observer } from 'mobx-react';
import ListaServicosAcessorios from './ListaServicosAcessorios';
import SimulacaoServicosAcessStore from '../stores/SimulacaoServicosAcessStore';
import { E_CONDICAO, E_TIPO_TELA } from '../stores/Enum';

@inject("store")
@observer
export default class AddServicosAcessorios extends Component {
    constructor(props) {
        super(props);

        this.tipoTela = this.props.tipoTela;
        this.items = this.props.items;

        switch (this.tipoTela) {
            case E_TIPO_TELA.Cabotagem:
                this.dataStore = this.props.controllers.cabStore;
                break;
            case E_TIPO_TELA.Importacao:
                this.dataStore = this.props.controllers.impStore;
                break;
            case E_TIPO_TELA.Exportacao:
                this.dataStore = this.props.controllers.expStore;
                break;
            case E_TIPO_TELA.Remocoes:
                this.dataStore = this.props.controllers.remStore;
                break;
            case E_TIPO_TELA.Transbordo:
                this.dataStore = this.props.controllers.traStore;
                break;
        }

        this.modalStore = this.props.store.modalStoreCustom;
        this.filterStore = this.props.controllers.filterStore;

        this.acessStore = new SimulacaoServicosAcessStore();
    }

    handleClickServicosAcessorios = async () => {
        const modalSelect = this.modalStore.openNewConfigurableModal('Atenção', {
            loading: true,
        });

        if (this.items.length == 1) {
            var item = this.items.at(0);

            var servicosJaIncluidos = this.dataStore.getServicosIncluidosPorCntr(item);
        }

        const requestBody = this.dataStore.getFilterForServicosAcessorios(this.filterStore.filters, item);

        await this.acessStore.populateServicosAcessorios(requestBody, servicosJaIncluidos);

        if (this.acessStore.servicosAcessorios.error) {
            modalSelect.appendConfigurableModal({
                body: <p dangerouslySetInnerHTML={{__html: this.acessStore.servicosAcessorios.error}}></p>,
                loading: false,
                hideCancel: true,
            });

            return;
        } 
        
        modalSelect.appendConfigurableModal({
            title: "Selecione os serviços",
            loading: false,
            className: "tamanho-modal-700",
            body: <ListaServicosAcessorios dataStore={this.acessStore} showQtd={false} />,
            okLabel: "LANÇAR",
            cancelLabel: "CANCELAR",
            onClickOk: saveAndClose.bind(this),
            resetOnSave: false,
        });

        async function saveAndClose() {
            for (const item of this.items) {

                const servicosJaIncluidos = this.dataStore.getServicosIncluidosPorCntr(item);

                const servicosSelecionados = this.acessStore.ServicosSelecionados
                    .filter(serv => !servicosJaIncluidos.find(({ Codigo, AgrupadorServico }) => Codigo == serv.Codigo || (AgrupadorServico && AgrupadorServico == serv.AgrupadorServico)));
                

                if (servicosSelecionados.length == 0) continue;

                const accRequestBody = this.dataStore.getFilterForServicosAcessorios(this.filterStore.filters, item)
                const servicosAcessorios = await this.acessStore.getServicosByItem(servicosSelecionados, accRequestBody, this.tipoTela);

                if (servicosAcessorios.length == 0) continue;
                
                const Filtros = this.dataStore.buildItemRequestBody(this.filterStore.filters, E_CONDICAO.Nao, item);
                
                const vincRequestBody = {
                    Filtros,
                    Servicos: servicosAcessorios.map(({ ClassificacaoId }) => ClassificacaoId),
                }
                
                const servicosVinculados = await this.acessStore.buscarServicosVinculados(vincRequestBody);

                const { Cntr, NumBl } = item;

                this.dataStore.addServicosAcessorios(servicosVinculados, Cntr, NumBl);
            }

            if (this.acessStore.servicosAcessorios.error) {
                this.modalStore.openNewConfigurableModal('Alerta!', {
                    body: <p>{this.acessStore.servicosAcessorios.error}</p>,
                    hideCancel: true,
                });
                return;
            }
            else {
                modalSelect.destroy();
            }
        }
    }

    render() {
        const { className, disabled, children } = this.props;
        return (
            <Button 
                outline
                className={className}
                onClick={() => this.handleClickServicosAcessorios()} 
                disabled={disabled}
            > 
                {children}
            </Button>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/AddServicosAcessorios.js